"use client";

export default function ErrorBoundary() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <main className="bg-white">
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-red-600 text-lg mb-4">
            Failed to load content. Please try again.
          </p>
          <button
            onClick={handleRetry}
            className="px-6 py-2 bg-[#1a5852] text-white rounded-lg hover:bg-[#0f3f3a] transition-colors cursor-pointer"
          >
            Retry
          </button>
        </div>
      </div>
    </main>
  );
}
